import { Component, Input, ViewChild, HostListener, EventEmitter, Output } from '@angular/core';
import { DwUtils } from 'src/app/components/utils/dw-utils';
import { Case } from 'src/app/models/case';
import { ServiceRequest } from 'src/app/models/service.request';
import { ServiceRequestsService } from 'src/app/services/service-requests.service';
import { Settings } from 'src/app/services/settings';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import {
	AddNewRequestCompactComponent
} from "../../requests/commands/add-new-request-compact/add-new-request-compact.component";
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-case-requests-list',
	templateUrl: './case-requests-list.component.html',
	styleUrls: ['./case-requests-list.component.css']
})
export class CaseRequestsListComponent {

	public strErr: string | null = '';
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	isEditing = false;

	public records: ServiceRequest[];
	public serviceRequestTypes: ServiceRequestType[];
	public result: boolean | null = false;
	public contentClassName: string | null = 'dwtable-container-bottom-without-save-strip';

	public caseId = 0;
	public _caseRecord: Case;
	strFilterText = '';

	public Idx: number | null = -1;
	public dataSource: MatTableDataSource<ServiceRequest>;
	public renderedData: Array<any>;
	public displayedColumns: string[];
	public busyCursor: boolean = false;
	public visibleAddEditMemberDialog = false;
	public primaryAgencyFlag: boolean;
	//readOnlyFlag = true;
	strAddEditHeader = '';
	public UOMList: any;
	public selectedCase: Case;
	public selectedRequest: any;
	public addNewRequestDlg: boolean = false;
	public visibleAddNewCaseRequest = false;
	public showAssignedAgencyColumn = false;
	showAllAgency = false;
	showaRestrictedAgency = false;
	public restrictedAgencyFlag = false;


	@ViewChild('newRequest', { static: true }) newRequest: AddNewRequestCompactComponent;

	fromSource: string;
	@Input() set from(value: string) {
		this.fromSource = value;
	}

	@Input() set caseRecord(val: Case) {
		this._caseRecord = val;
	}

	constructor(private serviceRequestsService: ServiceRequestsService,
		private serviceDefService: ServiceDefService,
		public dialog: MatDialog, private datePipe: DatePipe) {
	}

	public ngOnInit() {
		this.setSecurityPrivileges();
	}
	setSecurityPrivileges() {
		if (this.fromSource === 'cases') {
			this.visibleAddNewCaseRequest = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CASE_REQUESTS_ADD_REQUEST', "EXECUTE");
			this.showAssignedAgencyColumn = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CASE_REQUESTS_AGENCY', "SHOW");
			this.showAllAgency = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CASE_REQUESTS_SHOW_ALL_AGENCIES', "SHOW");
			this.showaRestrictedAgency = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS_CASE_REQUESTS_AGENCY', "SHOW");
		} else {
			this.visibleAddNewCaseRequest = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_REQUESTS_ADD_REQUEST', "EXECUTE");
			this.showAssignedAgencyColumn = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_REQUESTS_AGENCY', "SHOW");
			this.showAllAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_REQUESTS_SHOW_ALL_AGENCIES', "SHOW");
			this.showaRestrictedAgency = Settings.getInstance().hasPrivilege('REQUEST_DETAIL_CASE_REQUESTS_AGENCY', "SHOW");
		}
		if (this.showAssignedAgencyColumn) {
			this.displayedColumns = ['id', 'serviceRequestDesc', 'serviceRange', 'amountRequested', 'totalAmountProvided', 'primaryAgency', 'dateCompleted', 'requestStatusDesc'];
		} else {
			this.displayedColumns = ['id', 'serviceRequestDesc', 'serviceRange', 'amountRequested', 'totalAmountProvided', 'dateCompleted', 'requestStatusDesc'];
		}
		if (this.showAllAgency === false && this.showaRestrictedAgency === true) {
			this.restrictedAgencyFlag = true;
		}

	}
	public onShowHandler(selectedCase: Case) {

		if (selectedCase === undefined) {
			return;
		}

		this.selectedCase = selectedCase;
		this.caseId = this.selectedCase.id;

		if (this.caseId < 1) {
			return;
		}

		this.isEditing = false;
		this.busyCursor = true;
		this.queryRecords();
	}
	public queryRecords(): void {
		this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
			(result1) => {
				this.serviceRequestTypes = result1;
				Settings.getInstance().serviceRequestTypesList = result1;
				this.busyCursor = false;

				this.serviceDefService.getAllServiceDef().subscribe(
					(result2) => {
						Settings.getInstance().serviceDefsList = result2;
						if (Settings.getInstance().uomList && Settings.getInstance().uomList.length > 0) {
							this.loadServiceRequests();
						} else {
							this.serviceDefService.getActiveUnitOfMeasures().subscribe(
								(result3) => {
									let uomList = new Array();
									for (const rec of result3) {
										uomList.push({ id: rec.description, description: rec.description });
									}
									Settings.getInstance().uomList = uomList;
									this.loadServiceRequests();
								},
								(error3) => {
									Settings.getInstance().handleError('Error: unable to retrieve unit of measures');
								}
							)
						}
					},
					(error2) => {
						Settings.getInstance().handleError('Error: unable to retrieve service defs from' +
							' the' +
							' service');
						this.busyCursor = false;
					}
				);
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve request types from the service');
				this.busyCursor = false;
			}
		);
	}
	public loadServiceRequests() {
		if(this.showAllAgency===false &&this.showaRestrictedAgency===false){
			return;
		}
		this.busyCursor = true;
		this.serviceRequestsService.getAllServiceRequestsByCaseId(this.caseId, this.restrictedAgencyFlag).subscribe(
			(result2) => {
				this.records = result2;
				for (const rec of this.records) {
					if (rec.serviceDefId) {
						const serviceDef = Settings.getInstance().getServiceDef(rec.serviceDefId);
						if (serviceDef) {
							rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId) + ': ' + serviceDef.description;
						} else {
							rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId);
						}
					} else {
						rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId);
					}
					rec.startDate = DwUtils.formatUTCToTZDate(rec.startDate, true);
					rec.endDate = DwUtils.formatUTCToTZDate(rec.endDate, true);

					rec.requestStatusDesc = this.getRequestStatusDesc(rec.requestStatusId);
					rec['primaryAgency'] = this.getAgencyName(rec.agencyId);
					try {
						rec['serviceRange'] = this.datePipe.transform(rec.startDate) + ' - ' + this.datePipe.transform(rec.endDate);
					} catch (e) {

					}
					rec.collabList = '';
				}
				this.dataSource = new MatTableDataSource(this.records);
				this.dataSource.sort = this.sort;
				this.busyCursor = false;
			},
			(error1) => {
				Settings.getInstance().handleError('Error: unable to retrieve family details from the server');
				this.busyCursor = false;
			}
		);
	}

	public getServiceDefDescription(serviceDefId: number) {
		return Settings.getInstance().getServiceDefDescription(serviceDefId);
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}
	public getRequestTypeDesc(paramId: number) {
		if (!this.serviceRequestTypes) {
			return;
		}
		for (const rec of this.serviceRequestTypes) {
			if (rec.id === paramId) {
				return rec.description;
			}
		}
		return 'Undefined';
	}
	public requestStatusLabel(requestStatusId: number): string {
		return this.getRequestStatusDesc(requestStatusId);
	}
	public getRequestStatusDesc(paramId: number) {
		for (const rec of Settings.getInstance().requestStatuses) {
			if (rec.id === paramId) {
				//console.log('paramId: '+paramId+'   '+rec.id+' '+rec.description+'   '+rec.shortDescription);
				return rec.shortDescription;
			}
		}
		return 'Undefined';
	}

	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {

		if (event.direction === 'asc') {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					a[event.active] - (b[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					a[event.active].localeCompare(b[event.active]));
			}
		} else {
			if (event.active === 'id') {
				this.records.sort((a, b) =>
					b[event.active] - (a[event.active]));
			}
			else {
				this.records.sort((a, b) =>
					b[event.active].localeCompare(a[event.active]));
			}
		}
	}
	public onRowClicked(row: any): void {
		this.selectedRequest = row;
		this.selectRow();

	}
	public selectRow() {
		if (this.selectedRequest.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRequest.id);
	}
	public unSelectRow() {

		this.Idx = -1;
		this.selectedRequest = new ServiceRequest();

	}
	public tableKeyDown(event: KeyboardEvent) {

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRequest = this.dataSource.filteredData[++this.Idx];
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRequest = this.dataSource.filteredData[--this.Idx];

			}
		}
	}

	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date, number)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else if (!isNaN(value)) {
			return parseFloat(value);
		} else {
			return value ?? '';
		}
	}

	public applyFilter(filterValue: string) {

		if (this.dataSource === undefined) {
			return;
		}
		this.dataSource.filter = filterValue.trim().toLowerCase();
	}
	public clearFilter() {
		if (this.dataSource === undefined) {
			return;
		}
		//this.unSelectRow();
		this.dataSource.filter = '';
	}
	public doAddNew(): void {
		this.addNewRequestDlg = true;
		this.newRequest.onShowHandler(this.selectedCase.id,
			this.selectedCase.caseNumber,
			this.selectedCase.firstName + ' ' + this.selectedCase.lastName, this.selectedCase.currentNeed);
	}
	public doSubmitNewRequestEvent(event: any): void {
		this.addNewRequestDlg = false;
		this.queryRecords();
	}
	public amountLabel(id: number, requestFlag: boolean): string {
		if (id === null || !this.records) { return '-'; }

		const selected = this.records.find(s => s.id === id);
		if (selected === undefined) { return ''; }
		if (selected.unitOfMeasure === undefined) { selected.unitOfMeasure = '' }

		let val: number = null;
		if (requestFlag === true) {
			val = selected.amountRequested;
		}
		else {
			val = selected.totalAmountProvided;
		}

		return DwUtils.returnAmountString(val, selected.unitOfMeasure);
	}
}
